import moment from 'moment/moment'
import store from '@/stores/'
import UNIQUE from '@/common/unique'

const langValue = function (val) {
  const obj = Object.assign({}, store.state.setting.lang.langValue)
  Object.keys(obj).forEach(function (x) {
    obj[x] = val
  })
  return obj
}
export default {
  id: 'postcode',
  name: 'postcode',
  type: 'action',
  moduleName: 'editor_module_postcode',
  dataSet: {
    mods: 'postcode',
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'postcode',
        value: langValue('주소 찾기')
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'background',
        'border'
      ]
    },
    action: {
      name: 'postcode',
      isRequired: true,
      label: langValue('Postcode'),
      labelValue: 'Postcode',
      labelFontSize: 'default',
      valueFontSize: 'default'
    },
    detail: null
  }
}
